// material-ui
import { Box, useMediaQuery } from '@mui/material';

// project import
/*import Search from './Search';*/
import Profile from './Profile';
//import Logout from './Logout';
/*import Customization from './Customization';*/
//import MobileSection from './MobileSection';

import useConfig from 'hooks/useConfig';
import DrawerHeader from 'layout/Dashboard/Drawer/DrawerHeader';

import { MenuOrientation } from 'config';

// notifications import
import { NotificationsBadge } from 'contexts/notifications';
import TaskButton from './TaskButton';
import UserName from './userName';

// whatsapp
import WhatsappHeaderIcon from 'components/worten/whatsapp-chat/components/WhatsappHeaderIcon';

// ==============================|| HEADER - CONTENT ||============================== //

const HeaderContent = () => {
  const { menuOrientation } = useConfig();

  const downLG = useMediaQuery((theme) => theme.breakpoints.down('lg'));

  return (
    <>
      
      {menuOrientation === MenuOrientation.HORIZONTAL && !downLG && (
        <DrawerHeader open={true} />
      )}
      {/*!downLG && <Search />*/}
      {!downLG && <UserName />}
      <Box sx={{ width: '100%', ml: 1 }}/>
      {/* <NotificationsBadge /> */}
      {/* <TaskButton /> */}
      <WhatsappHeaderIcon />
      <Profile />
      {/*!downLG && <Logout />*/}
      {/* <Customization /> */}
      {/*downLG && <MobileSection />*/}
    </>
  );
};

export default HeaderContent;
